/**
 * Hình thức cấp phát (Hạch toán đồng thời)
 */
export default {
  Budget: 0, // Dự toán
  TreasuryWarrant: 1, // Lệnh chi
  InKind: 2, // Hiện vật
  RecordReceiptExpense: 3, // Ghi thu - Ghi chi
  Other: 4, // Khác
};
